import { useEffect, useRef } from "react";
import changelogText from "virtual:changelog";
import { Workspace } from "../components/Shell";
import { SettingsHead } from "../components/AccountTabs";
import { parseChangelog, weekGroups } from "../lib/changelog";

/* W72 STEP 8 — WHAT CHANGED, inside the app: the SAME list as `coachwork.io/changes`, from the same file
 * (`CHANGELOG.md`, served as `virtual:changelog` by the `ht-changelog` plugin — the one reader) through the same
 * parser and the same week grouping. It is parsed at module load: a malformed file has already failed the build. */
const GROUPS = weekGroups(parseChangelog(changelogText));

export function WhatChanged({ foreground = true }: { foreground?: boolean }) {
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => { if (foreground) heading.current?.focus(); }, [foreground]);
  return (
    <Workspace>
      <main id="main" className="account-page changes-page ours-page">
        <SettingsHead current="changes" headingRef={heading} />
        <p className="ht-caption yourdata-lede">
            Every change, dated, with who asked for it — the same list as <a className="ht-link" href="/changes">coachwork.io/changes</a>.
        </p>
        {GROUPS.map((g) => (
          <section key={g.key} className="changes-week" aria-labelledby={`changes-${g.key}`}>
            <h2 id={`changes-${g.key}`} className="changes-week-head">{g.heading}</h2>
            <ol className="changes-list">
              {g.entries.map((e) => (
                <li key={`${e.line}`} className="changes-entry">
                  <span className={`changes-kind changes-kind-${e.kind.toLowerCase()}`}>{e.kind}</span>
                  <div className="changes-body">
                    <h3 className="changes-title">{e.title}</h3>
                    <p className="changes-what">{e.sentence} <span className="changes-who">{e.reporter}.</span></p>
                  </div>
                </li>
              ))}
            </ol>
          </section>
        ))}
      </main>
    </Workspace>
  );
}
